interface ProgressBarProps {
  current: number;
  total: number;
  answeredCount: number;
}

export default function ProgressBar({
  current,
  total,
  answeredCount,
}: ProgressBarProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="font-sans text-sm text-text-secondary">
          Question {current} of {total}
        </p>
        <span className="font-sans text-xs font-medium bg-success/10 text-success px-2.5 py-1 rounded-full">
          {answeredCount} answered
        </span>
      </div>
      <div className="flex gap-1">
        {Array.from({ length: total }, (_, i) => {
          const index = i + 1;
          let colorClass = 'bg-border';
          if (index < current && i < answeredCount) {
            colorClass = 'bg-success';
          } else if (index === current) {
            colorClass = 'bg-primary';
          }
          return (
            <div
              key={i}
              className={`flex-1 h-1.5 rounded-full ${colorClass} transition-colors`}
            />
          );
        })}
      </div>
    </div>
  );
}
